import { computed, ExtractPropTypes, SetupContext } from 'vue'
import { COARSE_FEEDBACK_PROPS } from './types'

type CoarseFeedbackPropType = ExtractPropTypes<typeof COARSE_FEEDBACK_PROPS>

/**
 *
 * @param props
 * @param context
 */
export function setup(props: CoarseFeedbackPropType, context: SetupContext) {
  const submitCoarseFeedback = (reason: boolean) => {
    context.emit('submitCoarseFeedback', reason)
  }

  const disabled = computed(() => props.coarseFeedback !== undefined)

  const showThumbsUp = computed(
    () => props.coarseFeedback === true || props.coarseFeedback === undefined
  )
  const showThumbsDown = computed(
    () => props.coarseFeedback === false || props.coarseFeedback === undefined
  )

  return {
    submitCoarseFeedback,
    disabled,
    showThumbsDown,
    showThumbsUp,
  }
}
